import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';

import Vue from 'vue';
import LogRocket from 'logrocket';

import store from './services/store';
import router from './services/router';
import initApp from './services/core';

import addPwaSupport from './plugins/pwa';
import vuetify from './plugins/vuetify';
import './plugins/apex';

import App from './App.vue';

Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'production') {
  addPwaSupport();
  LogRocket.init('m058hu/clients-w2pzx');
}

initApp();

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
